// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c551e96","879":"b38b893b"}[chunkId] + ".chunk.js";
};